var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"entryNo"}},[_c('div',{staticClass:"searchArea"},[_c('div',{staticClass:"searchBar"},[_c('SearchBar',{on:{"refresh":_vm.refreshIt}})],1)]),_c('div',{staticClass:"mainContent"},[_c('div',{staticClass:"entryResults"},[_c('EntryNoResult',{key:_vm.refresh})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }